var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-upload" },
    [
      _c(
        "el-form",
        [
          _c(
            "draggable",
            {
              staticStyle: { display: "flex" },
              on: { start: _vm.start, end: _vm.end },
              model: {
                value: _vm.fileList,
                callback: function ($$v) {
                  _vm.fileList = $$v
                },
                expression: "fileList",
              },
            },
            [
              _vm._l(_vm.fileList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item + index,
                    staticClass: "itemI",
                    on: {
                      mouseenter: function ($event) {
                        return _vm.mouseenter($event, index)
                      },
                      mouseleave: _vm.mouseleave,
                    },
                  },
                  [
                    _c("el-image", {
                      staticStyle: {
                        width: "146px",
                        height: "146px",
                        "border-radius": "6px",
                      },
                      attrs: { src: item.url, "preview-src-list": [item] },
                    }),
                    index == 0
                      ? _c("img", {
                          staticStyle: {
                            width: "68px",
                            height: "68px",
                            "border-radius": "6px",
                            "z-index": "999",
                            position: "absolute",
                            top: "0px",
                            left: "0px",
                          },
                          attrs: { src: require("../../assets/zhutu.png") },
                        })
                      : _vm._e(),
                    _vm.isMark && _vm.indexM == index
                      ? _c("div", { staticClass: "mark" }, [
                          _c("i", {
                            staticClass: "el-icon-zoom-in",
                            staticStyle: {
                              color: "white",
                              "font-size": "20px",
                              "margin-right": "10px",
                              "z-index": "9999",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handlePictureCardPreview(item)
                              },
                            },
                          }),
                          _c("i", {
                            staticClass: "el-icon-delete",
                            staticStyle: {
                              color: "white",
                              "font-size": "20px",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleRemove(item, index)
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm.fileList.length <= 9
                ? _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        limit: _vm.limit,
                        action: "",
                        accept: "image/*",
                        "http-request": _vm.uploadFile,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        "file-list": _vm.fileList,
                        "on-preview": _vm.handlePictureCardPreview,
                        "on-exceed": _vm.handleExceed,
                        "show-file-list": false,
                        multiple: "",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon",
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  width: "100%",
                  fit: "contain",
                  src: _vm.dialogImageUrl,
                  alt: "",
                },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }